import { Injectable } from '@angular/core';
import {FormGroup} from "@angular/forms";

@Injectable({
  providedIn: 'root',
})
export class ActiveFormService {
  private form = null;
  private menuOpen: Boolean = false;
  private path: String = '';
  private isFormChanged: Boolean = false;
  private activeFormNode: Object = {};
  private nodeExit: Boolean = false;

  public focus: String = '';
  public topPosition: string;
  public currentFocusedElement: HTMLElement;
  public isReadOnly: boolean;

  getStatuses() {
    return {
      focus: this.focus,
      menuOpen: this.menuOpen,
      path: this.path,
    };
  }

  setFocusStatus(status: String, path?: String) {
    this.focus = status;
    this.path = path ? path : '';
  }

  setMenuOpenStatus(status) {
    this.menuOpen = status;
    if (!status) {
      this.focus = '';
    }
  }

  setActiveForm(form) {
    this.form = form;
  }
  removeTouchedForm(form: FormGroup) {
    form.markAsUntouched();
    form.markAsPristine();
  }

  getActiveForm() {
    return this.form;
  }

  setActiveFormNode(node) {
    this.activeFormNode = node;
  }

  getActiveFormNode() {
    return this.activeFormNode;
  }

  clearActiveForm() {
    this.setMenuOpenStatus(false);
    this.clearFocus();
    if (this.form && this.form.touched && this.form.dirty) {
      this.setIsFormChanged(true);
    }
    this.form = null;
  }

  setFormValue(value, name) {
    if (this.form && this.path) {
      const item = this.form.get(this.path);
      let valueToSet = value;
      if (Array.isArray(item.value)) {
        let arrItem = item.value[0];
        if (typeof arrItem === 'object') {
          if (arrItem.hasOwnProperty(name)) {
            arrItem[name] = value;
          } else {
            if (arrItem.hasOwnProperty('object') && arrItem.object.hasOwnProperty(name)) {
              arrItem.object[name] = value;
            }
          }
        } else {
          arrItem = value;
        }
        valueToSet = [arrItem];
      }
      item.setValue(valueToSet);
    }
  }

  setIsFormChanged(value) {
    this.isFormChanged = value;
  }

  getIsFormChanged() {
    return this.isFormChanged;
  }

  getNodeExit() {
    return this.nodeExit;
  }

  setNodeExit(value) {
    this.nodeExit = value;
  }

  clearFocus() {
    if (!this.menuOpen) {
      this.focus = '';
    }
  }

  public setPosition(id: string, path: string, element: HTMLElement) {
    if (element) {
      this.currentFocusedElement = element;
      this.isReadOnly = element.getAttributeNames()?.includes('readonly');
      const viewportOffset = element.getBoundingClientRect();
      const top = viewportOffset.top;
      this.topPosition = `${top}px`;
      return;
    }
    this.setMenuOpenStatus(false);
    this.topPosition = '250px';
    return;
  }
}
